<template>
    <div class="popup">
        <div class="popup-inner">
            <ChangeMobileForm :popup="true" class="pb-1 border-0 shadow-none"/>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import ChangeMobileForm from './ChangeMobileForm.vue';

export default {
    name: 'Popup',
    components: {
        ChangeMobileForm
    },
    computed: {
        ...mapGetters(['getUser']),
    },
}
</script>

<style scoped lang="scss">
#app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    margin-top: 60px;
}

.error_message {
    color: red;
    font-size: 30px;
}
</style>
